<template>
  <div class="fff">
    <div class="Browser_title">{{ $t("settings.title") }}</div>
    <div class="Setting_ul" :style="{ height: isshow == 5 ? 'auto' : '75px' }">
      <img v-if="isshow != 5" src="@/assets/img/left2.png" />
      <img v-if="isshow == 5" src="@/assets/img/dow.png" />
      <div
        @click="isshow == 5 ? (isshow = 0) : (isshow = 5)"
        class="Browser_title Setting_l_title helveticaBold"
      >
        {{ $t("settings.tips1") }}
      </div>
      <div class="Setting_li">
        <div>{{ $t("settings.tips2") }}</div>
        <input v-model="systemName" />
      </div>
      <div @click="editDeviceName" class="loginButton">
        {{ $t("settings.tips3") }}
      </div>
    </div>
    <div class="Setting_ul" :style="{ height: isshow == 1 ? 'auto' : '75px' }">
      <img v-if="isshow != 1" src="@/assets/img/left2.png" />
      <img v-if="isshow == 1" src="@/assets/img/dow.png" />
      <div
        class="Browser_title Setting_l_title helveticaBold"
        @click="isshow == 1 ? (isshow = 0) : (isshow = 1)"
      >
        {{ $t("settings.tips4") }}
      </div>

      <div class="Setting_li">
        <div>{{ $t("settings.tips5") }}</div>
        <input v-model="newpwd" :type="newpwdE ? 'text' : 'password'" />
        <div class="login_input">
          <img
            v-if="!newpwdE"
            @click="newpwdE = true"
            src="@/assets/img/ege1.png"
            class="login_input_eye"
          />
          <img
            v-else
            @click="newpwdE = false"
            src="@/assets/img/ege.png"
            class="login_input_eye"
          />
        </div>
      </div>
      <div class="Setting_li">
        <div>{{ $t("settings.tips6") }}</div>
        <input v-model="newpwd2" :type="newpwd2E ? 'text' : 'password'" />
        <div class="login_input">
          <img
            v-if="!newpwd2E"
            @click="newpwd2E = true"
            src="@/assets/img/ege1.png"
            class="login_input_eye"
          />
          <img
            v-else
            @click="newpwd2E = false"
            src="@/assets/img/ege.png"
            class="login_input_eye"
          />
        </div>
      </div>
      <div class="Setting_li" @click.stop>
        <div>{{ $t("settings.tips7") }}</div>
        <input v-model="oldpwd" :type="oldpwdE ? 'text' : 'password'" />
        <div class="login_input">
          <img
            v-if="!oldpwdE"
            @click="oldpwdE = true"
            src="@/assets/img/ege1.png"
            class="login_input_eye"
          />
          <img
            v-else
            @click="oldpwdE = false"
            src="@/assets/img/ege.png"
            class="login_input_eye"
          />
        </div>
      </div>
      <div @click.stop="Changepassword()" class="loginButton">
        {{ $t("settings.tips3") }}
      </div>
    </div>
    <div class="Setting_ul" :style="{ height: isshow == 2 ? 'auto' : '75px' }">
      <img v-if="isshow != 2" src="@/assets/img/left2.png" />
      <img v-if="isshow == 2" src="@/assets/img/dow.png" />
      <div
        @click="isshow == 2 ? (isshow = 0) : (isshow = 2)"
        class="Browser_title Setting_l_title helveticaBold"
      >
        {{ $t("settings.tips8") }}
      </div>
      <div class="Setting_li">
        <div>{{ $t("settings.tips9") }}</div>
        <input v-model.trim="email" />
      </div>
      <div class="Setting_li">
        <div>{{ $t("settings.tips10") }}</div>
        <input v-model.trim="reEmail" />
      </div>
      <div class="Setting_li">
        <div>{{ $t("settings.tips11") }}</div>
        <input v-model="pwd" :type="newpwd3E ? 'text' : 'password'" />
        <div class="login_input">
          <img
            v-if="!newpwd3E"
            @click="newpwd3E = true"
            src="@/assets/img/ege1.png"
            class="login_input_eye"
          />
          <img
            v-else
            @click="newpwd3E = false"
            src="@/assets/img/ege.png"
            class="login_input_eye"
          />
        </div>
      </div>
      <div @click="Changeemail(email, reEmail)" class="loginButton">
        {{ $t("settings.tips3") }}
      </div>
    </div>
    <div class="Setting_ul" :style="{ height: isshow == 4 ? 'auto' : '75px' }">
      <img v-if="isshow != 4" src="@/assets/img/left2.png" />
      <img v-if="isshow == 4" src="@/assets/img/dow.png" />
      <div
        @click="isshow == 4 ? (isshow = 0) : (isshow = 4)"
        class="Browser_title Setting_l_title helveticaBold"
      >
        {{ $t("settings.tips12") }}
      </div>
      <div class="Setting_li">
        <div>{{ $t("settings.tips13") }}</div>
        <el-select v-model="timeZone" placeholder="">
          <el-option
            v-for="item in timeZoneList"
            :key="item.id"
            :label="item.des"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <div>{{ $t("Update Interval") }}</div>
        <el-select v-model="intervalTime" placeholder="">
          <el-option
            v-for="item in intervalTimes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <!-- <div class="Setting_li">
        <div>{{ $t("settings.tips14") }}</div>
        <input ::value="$t('English')" disabled />
      </div> -->
      <div @click="editPreferences" class="loginButton">
        {{ $t("settings.tips3") }}
      </div>
    </div>
  </div>
</template>

<script>
import {
  userChangepwd,
  userChangeemail,
  updateGpsConfig,
  getTimeZone,
  setTimeZone,
  getCurrentTimeZone,
  updateEquipmentName,
  updateApiIntervalConfig,
  getApiIntervalConfig,
} from "@/api/user";

export default {
  inject: ["getheader"],
  name: "HelloWorld",
  data() {
    return {
      isreload: true,
      isshow: 0,
      newpwd: "",
      newpwd2: "",
      oldpwd: "",
      msg: "",
      email: "",
      pwd: "",
      gps_network: "",
      gps_interval: "",
      reEmail: null,
      oldpwdE: false,
      newpwdE: false,
      newpwd2E: false,
      newpwd3E: false,
      timeZoneList: [],
      timeZone: null,
      systemName: localStorage.getItem("systemName"),
      equipment_id: localStorage.getItem("systemId"),
      intervalTime: "",
      intervalTimes: [
        { value: 15, label: this.$t("15 mins") },
        { value: 30, label: this.$t("30 mins") },
        { value: 60, label: this.$t("1 hour") },
        { value: 360, label: this.$t("6 hours") },
        { value: 720, label: this.$t("12 hours") },
      ],
    };
  },
  async mounted() {
    this.isshow = this.$route.params.isshow ? this.$route.params.isshow : 0;
    await this.initGetTimeZone();
    let { code, data } = await getCurrentTimeZone();
    if (code === 1) {
      if (!data) {
        let utc = 0 - new Date().getTimezoneOffset() / 60;
        this.timeZone = {
          des: "UTC+" + (utc < 10 ? "0" + utc : utc),
        };
      } else {
        this.timeZone = data.id;
      }
    }

    const result = await getApiIntervalConfig();
    this.intervalTime = result.data.api_update_interval != null ? +result.data.api_update_interval : 15;
  },
  methods: {
    async initGetTimeZone() {
      let { code, data } = await getTimeZone();
      if (code === 1) {
        this.timeZoneList = data;
      }
    },
    Changepassword() {
      let reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
      if (!reg.test(this.newpwd)) {
        this.$message(this.$t("settings.msg1"));
        return false;
      }
      if (this.newpwd === this.newpwd2) {
        var key = {
          newpwd: this.newpwd,
          oldpwd: this.oldpwd,
        };
        userChangepwd(key).then((adj) => {
          // this.$message({
          //   message: adj.msg,
          //   type: 'success'
          // })
          if (adj.code !== 1) {
            this.$message({
              message: adj.msg,
              type: "error",
            });
          } else {
            this.$message({
              message: adj.msg,
              type: "success",
            });
          }
        });
      } else {
        this.$message({
          message: this.$t("settings.msg2"),
          type: "error",
        });
        // this.$message.error("The two passwords don't match")
      }
    },
    Changeemail(email, reEmail) {
      if (email !== reEmail) {
        this.$message({
          message: this.$t("settings.msg3"),
          type: "error",
        });
        return;
      }
      var key = {
        email: this.email,
        pwd: this.pwd,
      };
      userChangeemail(key).then((adj) => {
        if (adj.code === 1) {
          this.$message({
            message: adj.msg,
            type: "success",
          });
          localStorage.setItem("email", this.email);
        } else {
          this.$message({
            message: adj.msg,
            type: "error",
          });
        }
      });
    },
    Changegps() {
      var key = {
        gps_interval: this.gps_interval,
        gps_network: this.gps_network,
      };
      updateGpsConfig(key).then((adj) => {
        this.$message({
          message: adj.msg,
          type: "success",
        });
        console.log(adj.data);
      });
    },
    async editPreferences() {
      Promise.all([
        setTimeZone({ id: this.timeZone }),
        updateApiIntervalConfig({ api_update_interval: this.intervalTime }),
      ]).then(() => {
        this.$message({ message: this.$t("Success"), type: "success" });
      });
    },
    editDeviceName() {
      var key = {
        equipment_id: this.equipment_id,
        name: this.systemName,
      };
      updateEquipmentName(key).then((adj) => {
        this.$message({
          message: adj.msg,
          type: "success",
        });
        this.getheader();
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
>>> .Setting_li .el-select .el-input__inner {
  background-color: #00000000;
  width: 90%;
}
>>> .Setting_li .el-select .el-input__inner:focus {
  border: none !important;
}
.fff {
  width: 97%;
  margin: 20px auto;
  background: #fff;
  border-radius: 12px;
  -webkit-box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  overflow: hidden;
}

.Browser_title {
  line-height: 55px;
  padding-top: 10px;
  height: 55px;
  text-indent: 2.5%;
  font-weight: 700;
  font-size: 20px;
  color: #000927;
}
.Setting_ul {
  overflow: hidden;
  margin-left: 2.5%;
  width: 90%;
  max-width: 700px;
  position: relative;
  border-radius: 10px;
  border: 1px solid #e1e3e6;
  margin-bottom: 30px;
}
.Browser_title.Setting_l_title {
  font-size: 16px;
  margin-bottom: 10px;
}
.Setting_ul img {
  position: absolute;
  right: 27px;
  top: 27px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.Setting_li {
  margin: 0 2.5%;
  width: calc(100% - 5%);
  font-family: Noto Sans;
  font-size: 12px !important;
  color: #45484d;
  position: relative;
}
.login_input {
  position: absolute;
  height: 20px;
  width: 20px;
  right: 20px;
  top: 45px;
}
.login_input img {
  position: unset;
}
.Setting_li div {
  line-height: 20px;
  color: #707276;
}
.Setting_li input,
.Setting_li .el-select {
  border: 1px solid #e1e3e6;
  background: #f6f8fa;
  border-radius: 8px;
  height: 44px;
  line-height: 44px;
  margin: 10px 0 20px 0;
  /* padding-right: 20px; */
  width: calc(100% - 10px);
  text-indent: 10px;
}

.loginButton {
  width: 230px;
  height: 46px;
  line-height: 46px;
  float: left;
  /* margin-left: 2.5%; */
  margin: 0 calc((100% - 230px) / 2);
  margin-bottom: 30px;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Setting.vue